import React from 'react';

/**
 * Wraps dashboard page content so it fills the layout and scrolls vertically.
 * Use for simple pages (e.g. placeholder routes) that need consistent scroll behavior.
 */
export default function DashboardPageWrapper({ children, className = '' }) {
  return (
    <div className={`min-h-0 flex flex-col flex-1 h-full ${className}`.trim()}>
      <div className="flex-1 min-h-0 overflow-y-auto ">
        {children}
      </div>
    </div>
  );
}
